import * as React from 'react';
type Props = {
  className?: string;
};
export function Frequency({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Frequency"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.041 9.61104C16.3752 10.1113 16.6096 10.6677 16.735 11.25H15.8701C15.6657 11.25 15.4999 11.4157 15.4999 11.6202C15.4999 11.7042 15.5285 11.7858 15.5811 11.8514L17.2504 13.9381C17.3783 14.098 17.6215 14.098 17.7495 13.9381L19.4188 11.8514C19.4713 11.7858 19.4999 11.7042 19.4999 11.6202C19.4999 11.4157 19.3342 11.25 19.1298 11.25H18.2499C18.2499 11.205 18.2458 11.1594 18.2373 11.1136C18.0836 10.2825 17.7622 9.48708 17.2882 8.77769C16.6014 7.74988 15.6253 6.9488 14.4833 6.47576C13.3412 6.00271 12.0845 5.87894 10.8722 6.12009C9.65978 6.36125 8.54614 6.95651 7.67206 7.83059C7.37917 8.12348 7.37917 8.59835 7.67206 8.89125C7.96496 9.18414 8.43983 9.18414 8.73272 8.89125C9.39702 8.22695 10.2434 7.77455 11.1648 7.59127C12.0862 7.40799 13.0413 7.50206 13.9092 7.86158C14.7772 8.22109 15.519 8.82991 16.041 9.61104ZM4.5 12.3798C4.5 12.2958 4.52861 12.2142 4.58111 12.1486L6.25049 10.0619C6.3784 9.90198 6.6216 9.90198 6.74951 10.0619L8.41889 12.1486C8.47139 12.2142 8.5 12.2958 8.5 12.3798C8.5 12.5843 8.33428 12.75 8.12984 12.75H7.26491C7.39031 13.3323 7.62475 13.8887 7.95898 14.389C8.48092 15.1701 9.22277 15.7789 10.0907 16.1384C10.9587 16.4979 11.9137 16.592 12.8351 16.4087C13.7566 16.2254 14.6029 15.7731 15.2672 15.1088C15.5601 14.8159 16.035 14.8159 16.3279 15.1088C16.6208 15.4016 16.6208 15.8765 16.3279 16.1694C15.4538 17.0435 14.3402 17.6387 13.1278 17.8799C11.9154 18.1211 10.6587 17.9973 9.51669 17.5242C8.37465 17.0512 7.39854 16.2501 6.71178 15.2223C6.23778 14.5129 5.91632 13.7175 5.76263 12.8864C5.75416 12.8406 5.75005 12.795 5.75 12.75H4.87016C4.66572 12.75 4.5 12.5843 4.5 12.3798Z"
        fill="currentColor"
      />
    </svg>
  );
}
